import { useEffect, useState } from 'react';
import { InputAdornment, Paper } from '@mui/material';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { post } from 'api';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import IconifyIcon from 'components/base/IconifyIcon';
import DataGridPagination from 'components/pagination/DataGridPagination';
import StyledTextField from 'components/styled/StyledTextField';

const AttendanceTable = () => {
  const [selectedMonth, setSelectedMonth] = useState(moment());
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
    search: '',
  });
  const [search, setSearch] = useState('');
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  console.log(total);
  const generateDayColumns = (days) => {
    return Array.from({ length: days }, (_, i) => ({
      field: `day${i + 1}`,
      headerName: `${i + 1}`,
      width: 30,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Box
          // border: params.value == 'A' ? '1.5px solid #e53935' : '1.5px solid #000000',
          // color: params.value == 'A' ? '#e53935' : '#000000',
          sx={{
            background: params.value === 'A' ? '#fdecea' : 'transparent',
            color: params.value === 'A' ? '#d32f2f' : 'inherit',
            borderRadius: '50%',
            width: 28,
            height: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
          }}
        >
          {params.value}
        </Box>
      ),
    }));
  };
  const daysInMonth = selectedMonth.daysInMonth();

  const columns = [
    {
      field: 'name',
      headerName: 'Employee Name',
      width: 170,
    },

    ...generateDayColumns(daysInMonth),

    { field: 'P', headerName: 'P', width: 50 },
    { field: 'H', headerName: 'H', width: 50 },
    { field: 'A', headerName: 'A', width: 50 },
    { field: 'PH', headerName: 'PH', width: 50 },
    { field: 'total', headerName: 'Total', width: 50 },
  ];
  //   const rows = [
  //     {
  //       _id: '1',
  //       name: 'Vaishali Jadeja',
  //       day1: 'P',
  //       day2: 'P',
  //       day3: 'P',
  //       day4: 'PH',
  //       day5: 'P',
  //       day6: 'P',
  //       day7: 'A',
  //       day8: 'P',
  //       day9: 'P',
  //       day10: 'P',
  //       P: 7,
  //       H: 0,
  //       A: 1,
  //       PH: 1,
  //       total: 10,
  //     },
  //   ];
  const fetchData = async () => {
    try {
      const month = selectedMonth.format('M');
      const year = selectedMonth.format('YYYY');
      const res = await post('/users/attendance_records', {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        search: search,
        month,
        year,
      });
      if (res.status == 200) {
        setRows(res.data.rows);
        setTotal(res.data.total);
      } else {
        enqueueSnackbar(res.message || 'Error', { variant: 'error' });
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error', { variant: 'error' });
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedMonth, paginationModel, search]);
  return (
    <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <StyledTextField
            id="search-box"
            type="search"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search User Name"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              maxWidth: { sm: 200, md: 240 },
              flexGrow: { xs: 1, sm: 0 },
              mb: 3,
            }}
          />

          <DatePicker
            views={['month', 'year']}
            // openTo="month"
            label="Month"
            value={selectedMonth}
            maxDate={moment()}
            onChange={(newValue) => {
              setSelectedMonth(newValue);
              console.log(newValue.format('MM-YYYY'));
            }}
            slotProps={{
              textField: {
                size: 'small',
                sx: { width: 160 },
              },
            }}
          />
        </Box>
      </LocalizationProvider>

      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row._id}
          loading={false}
          autoHeight
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={(e) => {
            setPaginationModel(() => ({
              page: e.page,
              pageSize: e.pageSize,
              search: search,
            }));
          }}
          pageSizeOptions={[5, 10, 20]}
          pagination
          paginationMode="server"
          slots={{
            basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
          }}
        />
      </Box>
    </Paper>
  );
};

export default AttendanceTable;

//   const days = 31;
//   const employees = [
//     {
//       name: 'Vaishali Jadeja',
//       attendance: {
//         1: 'P',
//         2: 'P',
//         3: 'P',
//         4: 'PH',
//         5: 'P',
//         6: 'P',
//         7: 'A',
//         8: 'P',
//         9: 'P',
//         10: 'P',
//       },
//     },
//     {
//       name: 'Prafulla Jadeja',
//       attendance: {
//         1: 'P',
//         2: 'P',
//         3: 'P',
//         4: 'PH',
//         5: 'P',
//         6: 'P',
//         7: 'P',
//         8: 'P',
//         9: 'P',
//         10: 'P',
//       },
//     },
//   ];
{
  /* <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Employee</TableCell>

              {Array.from({ length: days }, (_, i) => (
                <TableCell key={i + 1} align="center">
                  {i + 1}
                </TableCell>
              ))}

              <TableCell>P</TableCell>
              <TableCell>H</TableCell>
              <TableCell>A</TableCell>
              <TableCell>PH</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {employees.map((emp, index) => {
              const counts = { P: 0, A: 0, H: 0, PH: 0 };

              Object.values(emp.attendance).forEach((v) => {
                if (counts[v] !== undefined) counts[v]++;
              });

              return (
                <TableRow key={index}>
                  <TableCell>{emp.name}</TableCell>

                  {Array.from({ length: days }, (_, i) => {
                    const val = emp.attendance[i + 1] || '-';
                    return (
                      <TableCell key={i} align="center">
                        {val}
                      </TableCell>
                    );
                  })}

                  <TableCell>{counts.P}</TableCell>
                  <TableCell>{counts.H}</TableCell>
                  <TableCell>{counts.A}</TableCell>
                  <TableCell>{counts.PH}</TableCell>
                  <TableCell>{days}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer> 
       <TextField
          label="Date Of Cheque"
          type="date"
          variant="filled"
          fullWidth
          slotProps={{
            inputLabel: {
              shrink: true,
            },
            htmlInput: {
              max: moment().format('YYYY-MM-DD'), // 👉 disables future dates in calendar
              // onInvalid: (e) => e.preventDefault(), // ❗ blocks browser tooltip
            },
          }}
        />*/
}
